import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import { Root } from './styled.js';

const Strong = React.forwardRef((props, ref) => {
    return React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-strong' }, props, { ref: ref, theme: useTheme() }));
});
Strong.displayName = 'Strong';

export { Strong };
//# sourceMappingURL=Strong.js.map
